import { useCallback, useState } from "react";

import { DeleteModal } from "src/components/deleteModal";
import { ApiError } from "src/core/apiError";
import { Bilge } from "src/gen/rest/bilge/BilgeService";
import { DeleteLinkedAccountRequest } from "src/gen/schema/bilge/api";

interface DeleteBindingModalProps {
  readonly accountId: string;
  readonly botName: string;
  readonly platformName: string;
  readonly channelName: string;
  readonly serverName: string;
  readonly channelLabel: string;
  readonly show: boolean;
  readonly onClose: () => void;
  readonly onSuccess: () => void;
}

export const DeleteBindingModal = ({
  accountId,
  botName,
  platformName,
  channelName,
  serverName,
  channelLabel,
  show,
  onClose,
  onSuccess
}: DeleteBindingModalProps) => {
  const [error, setError] = useState<ApiError | undefined>();
  const [loading, setLoading] = useState<boolean>(false);

  const handleDelete = useCallback(() => {
    setError(undefined);
    setLoading(true);
    Bilge.deleteLinkedAccount(DeleteLinkedAccountRequest.create({ accountId }))
      .then(() => {
        onSuccess();
        onClose();
      })
      .catch(setError)
      .finally(() => {
        setLoading(false);
      });
  }, [accountId, onClose, onSuccess]);

  return (
    <DeleteModal
      show={show}
      title="Delete bot binding?"
      message={
        <>
          Deleting this binding removes <strong>{botName}</strong> from{" "}
          {platformName}. The <strong>{channelName}</strong> {channelLabel}
          {serverName && (
            <>
              {" "}
              on server <strong>{serverName}</strong>
            </>
          )}{" "}
          will no longer be authorized to use <strong>{botName}</strong>.
        </>
      }
      onCancel={onClose}
      onDelete={handleDelete}
      deleteText="Delete"
      error={error?.getMessage()}
      disabled={loading}
    />
  );
};
